export default function checkVersion(intervalMinutes = 1) {
  const VERSION_KEY = 'app_version'

  async function fetchVersion() {
    try {
      const response = await fetch('/version.json?ts=' + Date.now(), {cache: 'no-store'})
      if (!response.ok) throw new Error('Version check failed')
      const data = await response.json()
      return data.version
    } catch (err) {
      console.error('Failed to fetch version:', err)
      return null
    }
  }

  async function check() {
    const latestVersion = await fetchVersion()
    const currentVersion = localStorage.getItem(VERSION_KEY)
    console.log('[App] check. Reloading...')
    if (latestVersion && currentVersion && latestVersion !== currentVersion) {
      console.log('[App] New version detected. Reloading...')
      localStorage.setItem(VERSION_KEY, latestVersion)
      window.location.reload(true)
    } else if (latestVersion && !currentVersion) {
      localStorage.setItem(VERSION_KEY, latestVersion)
    }
  }

  check()
  setInterval(check, intervalMinutes * 60 * 1000)
}
